import { Schema } from "./schema/index.js";
export const GetStatusSchema = Schema.object({
    ready: Schema.boolean().required(),
    version: Schema.string().required(),
    maxUploadSize: Schema.number().required(),
    areRegistrationsOpen: Schema.boolean().required(),
    unverifiedAccountCullingDelay: Schema.number().required(),
});
//# sourceMappingURL=api.return-types.js.map